import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypePrecinctResourceFields {
  title: EntryFieldTypes.Symbol
  resourceType: EntryFieldTypes.Symbol<'training_video'>
  precinct: EntryFieldTypes.Symbol<
    | 'fast-phonics-peaks'
    | 'mathseeds-lessons'
    | 'reading-eggs-reading'
    | 'reading-eggs-spelling'
    | 'reading-eggs-storylands'
    | 'reading-eggspress-reading'
    | 'reading-eggspress-spelling'
  >
  description?: EntryFieldTypes.Text
  cover?: EntryFieldTypes.AssetLink
  file?: EntryFieldTypes.AssetLink
  videoUrl?: EntryFieldTypes.Symbol
  domains: EntryFieldTypes.Array<
    EntryFieldTypes.Symbol<'all' | 'au' | 'ca' | 'cn' | 'in' | 'kr' | 'nz' | 'th' | 'uk' | 'us' | 'za'>
  >
}

export type TypePrecinctResourceSkeleton = EntrySkeletonType<TypePrecinctResourceFields, 'precinctResource'>
export type TypePrecinctResource<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypePrecinctResourceSkeleton,
  Modifiers,
  Locales
>

export function isTypePrecinctResource<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypePrecinctResource<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'precinctResource'
}

export type TypePrecinctResourceWithoutLinkResolutionResponse = TypePrecinctResource<'WITHOUT_LINK_RESOLUTION'>
export type TypePrecinctResourceWithoutUnresolvableLinksResponse = TypePrecinctResource<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypePrecinctResourceWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> = TypePrecinctResource<
  'WITH_ALL_LOCALES',
  Locales
>
export type TypePrecinctResourceWithAllLocalesAndWithoutLinkResolutionResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypePrecinctResource<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypePrecinctResourceWithAllLocalesAndWithoutUnresolvableLinksResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypePrecinctResource<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
